// @ts-ignore
import React from "react";

import { JiraSoftwarePageTemplatePaidLpJswPm } from "../../templates/jira-software-page/src";

export const JiraSoftwarePagePaidLpJswPm = () => (
    <JiraSoftwarePageTemplatePaidLpJswPm />
);
